import e from"styled-components";const o=e.div`
	border-radius: ${({borderRadius:e})=>"number"==typeof e?e:14}px;
	background: ${({theme:e})=>e.bg.card};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	padding: ${({isTemplate:e})=>e?"6.371px":"16px"};
	display: flex;
	flex-direction: column;
`;export{o as NewsContainer};
